import * as Permission from '../../models/permissions/permissions';

export class GetRolePermissions {
  static readonly type = '[Permissions] Get';
  constructor(public RoleId: number, public isAdmin : boolean) {}
}
